module.exports = "/static/assets/50eb945c10ef707c968c854a30284594.png";